export const toFormData = <T extends Record<string, any>>(obj: T): FormData => {
  const formData = new FormData();

  const appendArrayValues = (key: string, value: any) => {
    for (const item of value) {
      if (item instanceof File || typeof item === 'string') {
        formData.append(key, item);
      } else {
        convert(item, key);
      }
    }
  };

  const convert = (obj: Record<string, any>, parentKey = '') => {
    for (const key in obj) {
      if (!obj.hasOwnProperty(key)) {
        continue;
      }

      const value = obj[key];
      const newKey = parentKey ? `${parentKey}.${key}` : key;
      if (Array.isArray(value)) {
        appendArrayValues(newKey, value);
      } else if (typeof value === 'object' && !(value instanceof File) && value !== null) {
        // If the value is an object, recursively convert it
        convert(value, newKey);
      } else if (value != null) {
        // For primitive values, use dot notation
        formData.append(newKey, value);
      }
    }
  };

  convert(obj);

  return formData;
};
